import { useState } from "react";
import { Container, Logo } from "@/components";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { MenuIcon } from "lucide-react";
import { Toggle } from "../toggle";
import { useTheme } from "../theme-provider/ThemeProvider";
import styles from "./navbar.module.css";

interface NavbarProps {
  className?: string;
}

const Header = ({ className }: NavbarProps) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme() || {
    theme: "light-theme",
    toggleTheme: () => {},
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleThemeChange = (newTheme: string) => {
    if (newTheme && newTheme !== theme) {
      toggleTheme();
    }
  };

  return (
    <header className={styles.header}>
      <nav className={clsx(styles.navbar, className)}>
        <Container>
          <div className={styles.navbarHeader}>
            <div className={styles.navbarBrand}>
              <Link to="/" onClick={closeMenu}>
                <Logo size="small" />
              </Link>
            </div>

            <button
              className={styles.navbarToggle}
              type="button"
              onClick={toggleMenu}
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation"
            >
              <MenuIcon size={24} className={styles.menuIcon} />
            </button>
            <div
              className={clsx(styles.navbarCollapse, {
                [styles.show]: isMenuOpen,
              })}
            >
              <ul className={styles.navbarNav}>
                <li className={styles.navItem}>
                  <Link
                    to="/"
                    className={clsx(styles.navLink, {
                      [styles.active]: isActive("/"),
                    })}
                    onClick={closeMenu}
                  >
                    Home
                  </Link>
                </li>
                <li className={styles.navItem}>
                  <Link
                    to="/services"
                    className={clsx(styles.navLink, {
                      [styles.active]: isActive("/services"),
                    })}
                    onClick={closeMenu}
                  >
                    Concrete Services
                  </Link>
                </li>
                <li className={styles.navItem}>
                  <Link
                    to="/gallery"
                    className={clsx(styles.navLink, {
                      [styles.active]: isActive("/gallery"),
                    })}
                    onClick={closeMenu}
                  >
                    Project Gallery
                  </Link>
                </li>
                <li className={styles.navItem}>
                  <Link
                    to="/contact"
                    className={clsx(styles.navLink, {
                      [styles.active]: isActive("/contact"),
                    })}
                    onClick={closeMenu}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
              <div className={styles.wrapper}>
                <span className={styles.phoneNumber}>
                  Free Estimates Call (321) 208-0016
                </span>
                <Toggle value={theme} onValueChange={handleThemeChange} />
              </div>
            </div>
          </div>
        </Container>
      </nav>
    </header>
  );
};

export default Header;
